import { render, staticRenderFns } from "./FPageSalesProducts.vue?vue&type=template&id=48331ea6&"
import script from "./FPageSalesProducts.vue?vue&type=script&lang=js&"
export * from "./FPageSalesProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports